import { useContext } from 'react'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { AccountLinksContext } from 'src/Libs/installation-rights-management/provider/AccountLinksContext'

interface CompanyLinkInfo {
  hasLink: boolean
  accountLink?: AccountLinkModel
  numberOfCompanies?: number
}
interface AccountLinksHook {
  getCompanyAccountLink: () => CompanyLinkInfo
}

const useAccountLinks = (): AccountLinksHook => {
  const accountLinksContext = useContext(AccountLinksContext)

  const getCompanyAccountLink = (): CompanyLinkInfo => {
    const companyAccountLink = accountLinksContext.accountLinks.find(accountLink => accountLink.accountType === 'company')
    const totalNumberOfCompanies = accountLinksContext.accountLinks.filter(accountLink => accountLink.accountType === 'company').length
    return { hasLink: Boolean(companyAccountLink), accountLink: companyAccountLink, numberOfCompanies: totalNumberOfCompanies }
  }

  return { getCompanyAccountLink }
}

export default useAccountLinks
